import React from 'react'
import { useSelector } from 'react-redux'
import { Typography, List, Button } from 'antd';
import { useHistory } from 'react-router-dom'
import { CheckCircleOutlined } from '@ant-design/icons';
const { Title } = Typography;


const ServiceItem = (props) => {
    // const user = useSelector(state => state.user)
    const profile = useSelector(state => state.profile)
    const history = useHistory()
    // const location = useLocation()

    ///purchase/:type/:id
    const onBuyClick =(id)=>{
        history.push("/purchase/services/" + id);
    }   

    function getCallToAction(srvc){
        let callToAction 
        if (srvc.type =="membership") {
            callToAction = "Subscribe For € " + props.service.priceEur
            if(props.service.payments == "yearly"){
                callToAction = callToAction + " / Year"
            }
            if(props.service.payments == "monthly"){
                callToAction = callToAction + " / Month"
            }
        }else{
            callToAction = "Book For € " + props.service.priceEur
        }
        return callToAction
    }

    return (
        <>
            <List
            size="small"
            header={<Title level={5}>{props.service.title}</Title>}
            bordered
            dataSource={props.service.package}
            renderItem={item => <List.Item >{item.title}</List.Item>}

            footer={
                <List.Item style={{justifyContent:"center"}}>
                    { props.service.type =="membership" 
                            && profile.odinMember 
                            ? 
                                <CheckCircleOutlined style={{ fontSize: '30px', color: 'rgb(20, 227, 186)' }} 
                                        theme="outlined"/>
                            :
                            <Button block type="primary"
                                onClick={() => {onBuyClick(props.service.id) }}
                            >
                                {getCallToAction(props.service)}
                            </Button>
                    }
                </List.Item>
            }

            style={{
                borderRadius: 10, 
                marginBottom: 25,
                boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.6)" 
            }}
            />
        </>
    )
}

export default ServiceItem
